import { getDeviceId } from "./deviceId";
import { openExternal } from "./clipboard";

/**
 * Open a Stripe pre-built payment link in a new tab. We append
 * `client_reference_id` (user.id when authed, else device-id) so the
 * webhook can attribute the entitlement on completion.
 */
export async function openStripeLink(paymentLink, { user } = {}) {
  if (!paymentLink) return false;
  const ref = (user && user.id) || getDeviceId();
  const sep = paymentLink.includes("?") ? "&" : "?";
  const url = `${paymentLink}${sep}client_reference_id=${encodeURIComponent(ref)}`;
  const result = await openExternal(url);
  return result === "opened";
}
